export default __webpack_public_path__ + "static/media/avatarD7.cacc1021.png";